module.exports = __webpack_public_path__ + "media/ad_preview/iphone_placeholder-9465f05f.jpg";